import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../../common/FormRenderer";
import { Button } from "react-bootstrap";
import { ACTIONS } from "../../../common/Constants";
import { getValue, preventDefault } from "../../../../utils/common";
import { useCreateState, useGetStates, useUpdateState } from "../../../../backend/masters";
import { toast } from 'react-toastify';
import { ERROR_MESSAGES } from "../../../../utils/constants";
import { FindDuplicateMasters, GetActionTitle } from "../Master.constants";
import { ResponseModel } from "../../../../models/responseModel";
import { DEFAULT_OPTIONS_PAYLOAD } from "../../../common/Table";

function AddEditState({ action, record : data, onClose, onSubmit }: any) {
    const [form, setForm] = useState<any>({});
    const [stateDetails, setStateDetails] = useState<any>({ hideButtons: true });
    const [defaultTime] = useState(new Date().getTime())
    const { states } = useGetStates({ ...DEFAULT_OPTIONS_PAYLOAD, t: defaultTime });

    const { updateState } = useUpdateState((state: ResponseModel) => {
        if (state && state.error_messages.length > 0) {
            toast.error(state.error_messages.join(', '));
        } else {
            toast.success(`${form.values.name.trim()} updated successfully.`);
            onSubmit();
        }
    }, errorCallback);

    const { createState } = useCreateState((state: any) => {
      if (state && state.error_messages.length > 0) {
        toast.error(state.error_messages.join(', '));
    } else {
        toast.success(`${form.values.name.trim()} created successfully.`);
        onSubmit();
    }
    }, errorCallback);

    function errorCallback() {
        toast.error(ERROR_MESSAGES.DEFAULT);
    }
    const schema = {
        fields: [
            {
                component: componentTypes.TEXT_FIELD,
                name: 'name',
                label: 'State Name',
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(data, 'name')
            },
            {
                component: componentTypes.TEXT_FIELD,
                name: 'code',
                label: 'State Code',
                validate: [
                    { type: validatorTypes.REQUIRED },
                    { type: validatorTypes.MAX_LENGTH, threshold: 2 },
                    { type: validatorTypes.PATTERN, pattern: /[a-zA-Z]{2}/, message: 'Should be alpha value of length 2' }
                ],
                styleClass: 'text-uppercase',
                content: getValue(data, 'code')

            }
        ],
    };

    function submitState(e: any) {
        preventDefault(e);
        if (form.valid) {
            const { code, name } = form.values;
            const existingData = states.filter((x: any) => x.id !== (data || {}).id);
            const duplicateStates = FindDuplicateMasters(existingData, { code, name });
            if (duplicateStates.length) {
                toast.error(`${duplicateStates.length} state(s) matching code or name. Please update code or name`);
                return;
            }
            const payload: any = {
                code: code.toUpperCase(),
                name: name.trim()
            };
            if (action === ACTIONS.EDIT) {
                payload['id'] = data.id;
                updateState(payload)
            } else if (action === ACTIONS.ADD) {
                createState(payload);
            }
        }
    }
    
    useEffect(() => {
        if (data) {
            setStateDetails({
                ...stateDetails, ...data
            });
        }
    }, [data]);

    return (
      <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
          <Modal.Header closeButton={true} onHide={onClose}>
              <Modal.Title className="bg">{GetActionTitle('State', action)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <FormRenderer FormTemplate={FormTemplate}
                  initialValues={{ hideButtons: true, ...data }}
                  componentMapper={ComponentMapper}
                  schema={schema}
                  debug={setForm}
              />
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
              {
                <>
                    <Button variant="outline-secondary" className="btn btn-outline-secondary px-4" onClick={onClose}>{'Cancel'}</Button>
                    <Button variant="primary" onClick={submitState} className="px-4" disabled={!form.valid}>{'Submit'}</Button>
                </>

              }
          </Modal.Footer>
      </Modal>
    )
}

export default AddEditState;
